import { ROUTES } from "./siteConfig";

/** Standort-Seiten mit Fokus auf Marketing / Social Media / Online-Marketing */
export const marketingLocationPages = {
  oesterreich: {
    path: "/marketing-agentur-oesterreich",
    title: "Marketing Agentur Österreich",
    metaTitle: "Marketing Agentur Österreich | Digital Marketing & Social Media",
    metaDescription:
      "Marketing Agentur für ganz Österreich: Digital Marketing, Social Media Marketing und digitale Vermarktung. Von Wolfsberg aus für Unternehmen in Wien, Graz, Kärnten und ganz Österreich.",
    h1: "Marketing Agentur Österreich – Digital Marketing & Social Media für Unternehmen",
    intro:
      "Marmoris ist Ihre Marketing-Agentur mit Sitz in Wolfsberg, Kärnten. Wir unterstützen Unternehmen in ganz Österreich mit digitaler Vermarktung, Social Media Marketing und einer starken Online-Präsenz – inklusive professioneller Websites als Teil Ihrer Strategie.",
    sections: [
      {
        title: "Digital Marketing und Social Media in ganz Österreich",
        content:
          "Ob Wien, Graz, Klagenfurt oder Villach: Wir entwickeln und betreuen Ihre digitale Präsenz. Dazu gehören Social Media Betreuung, Content-Strategie, Online-Marketing und bei Bedarf professionelle Websites. So werden Sie dort sichtbar, wo Ihre Kunden unterwegs sind.",
      },
      {
        title: "Warum eine Marketing-Agentur aus Kärnten?",
        content:
          "Als Agentur in Südkärnten kennen wir die regionalen Märkte und arbeiten gleichzeitig für Kunden in ganz Österreich. Persönliche Betreuung, klare Prozesse und ein Verständnis für österreichische KMU zeichnen uns aus.",
      },
    ],
    faqs: [
      {
        q: "Betreut Marmoris Kunden in ganz Österreich?",
        a: "Ja. Unser Sitz ist in Wolfsberg, Kärnten – die Zusammenarbeit erfolgt per Videocall, E-Mail und Projektmanagement. Viele unserer Kunden sitzen in Wien, Graz, Klagenfurt, Villach oder anderen Regionen Österreichs.",
      },
      {
        q: "Was umfasst Ihre Marketing-Beratung?",
        a: "Wir besprechen Ihre Ziele, Zielgruppen und Kanäle – von Social Media über Website bis zu Content und Werbung. Am Ende steht eine klare Strategie und die Umsetzung, die zu Ihnen passt.",
      },
    ],
    areaName: "Österreich",
  },
  kaernten: {
    path: "/marketing-agentur-kaernten",
    title: "Marketing Agentur Kärnten",
    metaTitle: "Marketing Agentur Kärnten | Digital Marketing & Social Media aus Wolfsberg",
    metaDescription:
      "Marketing Agentur Kärnten: Digital Marketing, Social Media Marketing und digitale Vermarktung für Unternehmen in Klagenfurt, Villach, Wolfsberg und ganz Kärnten.",
    h1: "Marketing Agentur Kärnten – Ihr Partner für digitale Vermarktung",
    intro:
      "Marmoris hat seinen Sitz in Wolfsberg, Kärnten. Wir unterstützen Unternehmen in ganz Kärnten – von Klagenfurt über Villach bis Wolfsberg – mit Digital Marketing, Social Media Betreuung und einer starken Online-Präsenz.",
    sections: [
      {
        title: "Digital Marketing in Kärnten aus einer Hand",
        content:
          "Von der Strategie bis zur Umsetzung: Social Media, Content, Website und Sichtbarkeit. Wir arbeiten mit Kunden in Klagenfurt, Villach, Wolfsberg und der gesamten Region Kärnten – persönlich und professionell.",
      },
    ],
    faqs: [
      {
        q: "Wo sitzt Marmoris in Kärnten?",
        a: "Unser Sitz ist in Wolfsberg, 9400 Wolfsberg, Kärnten. Die Zusammenarbeit kann vor Ort oder remote erfolgen.",
      },
    ],
    areaName: "Kärnten",
  },
  klagenfurt: {
    path: "/social-media-agentur-klagenfurt",
    title: "Social Media Agentur Klagenfurt",
    metaTitle: "Social Media Agentur Klagenfurt | Social Media Marketing & Betreuung",
    metaDescription:
      "Social Media Agentur für Klagenfurt und Umgebung: Social Media Marketing, Betreuung und Content-Strategie. Marmoris – Ihre Agentur aus Kärnten für Klagenfurt.",
    h1: "Social Media Agentur Klagenfurt – Sichtbar in den sozialen Netzwerken",
    intro:
      "Sie suchen eine Social Media Agentur für Klagenfurt am Wörthersee? Marmoris entwickelt und betreut Ihre Social-Media-Präsenz aus Kärnten – mit Strategie, Content und messbarer Umsetzung für Unternehmen in Klagenfurt und Region.",
    sections: [
      {
        title: "Social Media Marketing für Klagenfurt",
        content:
          "Ob LinkedIn, Instagram oder Facebook: Wir planen und betreuen Ihre Kanäle, erstellen passende Inhalte und sorgen für eine professionelle, zielgerichtete Präsenz. Ideal für KMU und Dienstleister in Klagenfurt und Umgebung.",
      },
    ],
    faqs: [
      {
        q: "Arbeitet Marmoris mit Kunden in Klagenfurt zusammen?",
        a: "Ja. Wir betreuen Kunden in Klagenfurt und Umgebung. Die Abstimmung erfolgt per Videocall und E-Mail; bei Bedarf sind Besuche vor Ort möglich.",
      },
    ],
    areaName: "Klagenfurt",
  },
  graz: {
    path: "/online-marketing-graz",
    title: "Online-Marketing Graz",
    metaTitle: "Online-Marketing Graz & Steiermark | Digital Marketing Agentur",
    metaDescription:
      "Online-Marketing für Graz und Steiermark: Digital Marketing, Social Media und digitale Vermarktung. Marmoris – Ihre Agentur für Graz und die Steiermark.",
    h1: "Online-Marketing Graz – Digitale Sichtbarkeit für die Steiermark",
    intro:
      "Unternehmen in Graz und der Steiermark vertrauen auf Marmoris für Online-Marketing, Social Media und digitale Vermarktung. Wir entwickeln Ihre Strategie und setzen sie um – mit klarem Fokus auf Sichtbarkeit und Ergebnisse.",
    sections: [
      {
        title: "Online-Marketing für Graz und Steiermark",
        content:
          "Von der Website über Social Media bis zu Content und Werbung: Wir bauen Ihre Online-Präsenz auf und betreuen sie strukturiert. So werden Sie in Graz und der Steiermark gefunden und wahrgenommen.",
      },
    ],
    faqs: [
      {
        q: "Betreut Marmoris auch Kunden in Graz?",
        a: "Ja. Wir arbeiten mit Kunden in Graz und der gesamten Steiermark. Die Kommunikation erfolgt remote; bei Bedarf sind Besuche möglich.",
      },
    ],
    areaName: "Graz",
  },
  wolfsberg: {
    path: "/digitale-vermarktung-wolfsberg",
    title: "Digitale Vermarktung Wolfsberg",
    metaTitle: "Digitale Vermarktung Wolfsberg | Marketing Agentur vor Ort",
    metaDescription:
      "Digitale Vermarktung in Wolfsberg und Lavanttal: Social Media, Online-Marketing und Websites. Marmoris – Ihre Marketing-Agentur vor Ort in Kärnten.",
    h1: "Digitale Vermarktung Wolfsberg – Ihre Agentur vor Ort",
    intro:
      "Marmoris ist in Wolfsberg, Kärnten, zu Hause. Wir unterstützen Unternehmen in Wolfsberg und dem Lavanttal mit digitaler Vermarktung, Social Media Marketing und Online-Präsenz – persönlich und professionell.",
    sections: [
      {
        title: "Digitale Vermarktung in Wolfsberg und Lavanttal",
        content:
          "Kurze Wege, persönliche Beratung: Als Wolfsberger Agentur kennen wir die Region. Von Social Media Betreuung über Online-Marketing bis zur Website – alles aus einer Hand für Ihre Sichtbarkeit im Netz.",
      },
    ],
    faqs: [
      {
        q: "Wo befindet sich Marmoris in Wolfsberg?",
        a: "Unser Sitz ist in 9400 Wolfsberg, Weinleiten 7. Gerne vereinbaren wir ein persönliches Gespräch vor Ort.",
      },
    ],
    areaName: "Wolfsberg",
  },
  villach: {
    path: "/marketing-agentur-villach",
    title: "Marketing Agentur Villach",
    metaTitle: "Marketing Agentur Villach | Digital Marketing & Social Media",
    metaDescription:
      "Marketing Agentur für Villach: Digital Marketing, Social Media Marketing und digitale Vermarktung für Unternehmen in Villach und Region.",
    h1: "Marketing Agentur Villach – Digital Marketing für Ihre Region",
    intro:
      "Unternehmen in Villach und Umgebung setzen auf Marmoris für Digital Marketing, Social Media und digitale Vermarktung. Wir entwickeln Ihre Strategie und betreuen Ihre Online-Präsenz – mit oder ohne professionelle Website.",
    sections: [
      {
        title: "Marketing für Villach aus Kärnten",
        content:
          "Ob Social Media Betreuung, Content-Strategie oder die Kombination mit einer neuen Website: Wir arbeiten mit Kunden in Villach und der Region und sorgen für eine klare, messbare Präsenz im Netz.",
      },
    ],
    faqs: [
      {
        q: "Kann ich als Unternehmen aus Villach mit Marmoris zusammenarbeiten?",
        a: "Ja. Viele unserer Kunden kommen aus Villach und der Umgebung. Die Zusammenarbeit ist ortsunabhängig möglich.",
      },
    ],
    areaName: "Villach",
  },
};
